module.exports = __webpack_public_path__ + "static/img/color.2bea9b60.png";